(function () {
  document.querySelectorAll('video[data-rate]').forEach(function (v) {
    var r = parseFloat(v.getAttribute('data-rate'));
    if (!isFinite(r) || r <= 0) { return; }
    var set = function () { try { v.playbackRate = r; } catch (e) {} };
    set();
    v.addEventListener('loadedmetadata', set);
    v.addEventListener('play', set);
    v.addEventListener('ratechange', function () { if (Math.abs(v.playbackRate - r) > 0.001) { set(); } });
  });

  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          var p = v.play();
          if (p && p.catch) { p.catch(function () {}); }
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.2 });
    document.querySelectorAll('video[autoplay]').forEach(function (v) { vio.observe(v); });
  }

  var rvs = document.querySelectorAll('.rv');
  if (!('IntersectionObserver' in window)) {
    rvs.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    rvs.forEach(function (el) { io.observe(el); });
  }

  var gn = document.getElementById('gn');
  var tg = document.querySelector('.gn-toggle');
  if (tg) {
    tg.addEventListener('click', function () { gn.classList.toggle('open'); });
  }
  document.querySelectorAll('.gn-links a').forEach(function (a) {
    a.addEventListener('click', function () { gn.classList.remove('open'); });
  });

  var drops = document.querySelectorAll('.gn-drop');
  function closeDrops() {
    drops.forEach(function (d) {
      d.classList.remove('open');
      d.querySelector('.gn-drop-btn').setAttribute('aria-expanded', 'false');
    });
  }
  drops.forEach(function (drop) {
    var btn = drop.querySelector('.gn-drop-btn');
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = drop.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  document.addEventListener('click', closeDrops);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrops(); gn.classList.remove('open'); }
  });

  var vids = document.querySelectorAll('video');
  if (vids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.play().catch(function () {}); }
        else { e.target.pause(); }
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { vio.observe(v); });
  }

  document.querySelectorAll('video[data-fade]').forEach(function (v) {
    var on = function () { v.classList.add('ready'); };
    if (v.readyState >= 2) { on(); } else { v.addEventListener('loadeddata', on, { once: true }); }
  });

  document.querySelectorAll('.vmute').forEach(function (btn) {
    var v = document.getElementById(btn.getAttribute('data-target'));
    if (!v) { return; }
    var sync = function () {
      var on = !v.muted;
      btn.classList.toggle('on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Mute video' : 'Unmute video');
    };
    btn.addEventListener('click', function () {
      v.muted = !v.muted;
      if (!v.muted) { v.play().catch(function () {}); }
      sync();
    });
    v.addEventListener('volumechange', sync);
    sync();
  });

  var film = document.getElementById('v-film');
  var fbar = document.querySelector('.film-bar');
  if (film && fbar) {
    var ffill = fbar.querySelector('i');
    film.addEventListener('click', function () {
      if (film.paused) { film.play().catch(function () {}); } else { film.pause(); }
    });
    fbar.addEventListener('click', function (e) {
      e.stopPropagation();
      var r = fbar.getBoundingClientRect();
      if (!r.width) { return; }
      var t = (e.clientX - r.left) / r.width;
      if (isFinite(film.duration) && film.duration > 0) {
        film.currentTime = Math.min(Math.max(t, 0), 1) * (film.duration - 0.1);
      }
    });
    var ftick = function () {
      ffill.style.width = (film.duration > 0 ? (film.currentTime / film.duration * 100) : 0) + '%';
    };
    film.addEventListener('timeupdate', ftick);
    film.addEventListener('loadedmetadata', ftick);
  }
})();
